import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { InviteConfig } from './invite.config';
import { InviteService } from './invite.service';
import { WelcomeModule } from '../welcome';

export const InviteModule = angular
  .module('app.invite', [uiRouter, WelcomeModule.name])
  .config(InviteConfig)
  .service('InviteService', InviteService);
